'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  !function (e, t) {
    "object" == (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.ramjet = t();
  }(undefined, function () {
    "use strict";
    function e() {
      document.body.appendChild(w), T = !0;
    }function t(e, n, o) {
      var i = o ? o(e, n) : e.cloneNode();if ("undefined" != typeof i) {
        var r = void 0,
            a = void 0,
            s = void 0,
            d = void 0;if (1 === e.nodeType) for (r = window.getComputedStyle(e), g.forEach(function (e) {
          i.style[e] = r[e];
        }), a = e.childNodes.length, s = 0; a > s; s += 1) {
          d = t(e.childNodes[s], n + 1, o), d && i.appendChild(d);
        }return i;
      }
    }function n(e, n, o, i) {
      var r = e.namespaceURI === b,
          a = e.getBoundingClientRect(),
          s = a.left,
          d = a.right,
          l = a.top,
          c = a.bottom,
          u = window.getComputedStyle(e),
          f = t(e, 0, o),
          m = { node: e, clone: f, isSvg: r, cx: (s + d) / 2, cy: (l + c) / 2, width: d - s, height: c - l, transform: null, borderRadius: null };if (r) {
        var p = e.getScreenCTM();m.transform = "matrix(" + [p.a, p.b, p.c, p.d, p.e, p.f].join(",") + ")", m.borderRadius = [0, 0, 0, 0], w.appendChild(f);
      } else {
        if (n) f.style.position = "fixed", f.style.top = l - parseInt(u.marginTop, 10) + "px", f.style.left = s - parseInt(u.marginLeft, 10) + "px";else {
          var y = e.offsetParent;if (null === y || y === document.body || i) {
            var h = document.documentElement;f.style.position = "absolute", f.style.top = l + window.pageYOffset - h.clientTop - parseInt(u.marginTop, 10) + "px", f.style.left = s + window.pageXOffset - h.clientLeft - parseInt(u.marginLeft, 10) + "px";
          } else {
            var v = window.getComputedStyle(y),
                g = y.getBoundingClientRect();f.style.position = "absolute", f.style.top = l - parseInt(u.marginTop, 10) - (g.top - parseInt(v.marginTop, 10)) + "px", f.style.left = s - parseInt(u.marginLeft, 10) - (g.left - parseInt(v.marginLeft, 10)) + "px";
          }
        }m.transform = "", m.borderRadius = [parseFloat(u.borderTopLeftRadius), parseFloat(u.borderTopRightRadius), parseFloat(u.borderBottomRightRadius), parseFloat(u.borderBottomLeftRadius)], i ? document.body.appendChild(f) : e.parentNode.appendChild(f);
      }return m;
    }function o(e) {
      e.__ramjetOriginalTransition__ = e.style.transition, e.style.transition = "", e.style.opacity = 0;
    }function i(e) {
      e.style.transition = "", e.style.opacity = 1, e.__ramjetOriginalTransition__ && setTimeout(function () {
        e.style.transition = e.__ramjetOriginalTransition__;
      });
    }function r(e) {
      for (; null !== e;) {
        if ("fixed" === window.getComputedStyle(e).position) return !0;e = e.namespaceURI === b ? e.parentNode : e.offsetParent;
      }return !1;
    }function a(e, t, n, o, i, r, a, s, d) {
      var l = e ? "translate(" + t + " " + n + ") scale(" + (1 + d * r) + " " + (1 + d * a) + ") translate(" + -t + " " + -n + ") translate(" + s * o + " " + s * i + ")" : "translate(" + s * o + "px," + s * i + "px) scale(" + (1 + d * r) + "," + (1 + d * a) + ")";return l;
    }function s(e, t, n, o, i) {
      var r = 1 + i * n,
          a = 1 + i * o;return e.map(function (e, n) {
        var o = t[n],
            s = (e + i * (o - e)) / r,
            d = (e + i * (o - e)) / a;return s + "px " + d + "px";
      });
    }function d(e) {
      return e;
    }function l(e) {
      return Math.pow(e, 3);
    }function c(e) {
      return Math.pow(e - 1, 3) + 1;
    }function u(e) {
      return (e /= .5) < 1 ? .5 * Math.pow(e, 3) : .5 * (Math.pow(e - 2, 3) + 2);
    }function f(e, t) {
      e.style.borderTopLeftRadius = t[0], e.style.borderTopRightRadius = t[1], e.style.borderBottomRightRadius = t[2], e.style.borderBottomLeftRadius = t[3];
    }function m(e) {
      var t = document.createElement("style");t.type = "text/css";var n = document.getElementsByTagName("head")[0],
          o = t.styleSheet;return o ? o.cssText = e : t.innerHTML = e, n.appendChild(t), function () {
        return n.removeChild(t);
      };
    }function p(e, t, n) {
      function o(n, o, i) {
        var d = e.cx + r * o,
            p = e.cy + l * o,
            y = s(e.borderRadius, t.borderRadius, c, u, o),
            h = s(t.borderRadius, e.borderRadius, f, m, 1 - o),
            b = a(!1, d, p, r, l, c, u, o, i) + " " + e.transform,
            w = a(!1, d, p, -r, -l, f, m, 1 - o, 1 - i) + " " + t.transform;v.push("\n			" + n + "% {\n				opacity: " + (1 - o) + ";\n				border-top-left-radius: " + y[0] + ";\n				border-top-right-radius: " + y[1] + ";\n				border-bottom-right-radius: " + y[2] + ";\n				border-bottom-left-radius: " + y[3] + ";\n				" + A + ": " + b + ";\n			}"), g.push("\n			" + n + "% {\n				opacity: " + o + ";\n				border-top-left-radius: " + h[0] + ";\n				border-top-right-radius: " + h[1] + ";\n				border-bottom-right-radius: " + h[2] + ";\n				border-bottom-left-radius: " + h[3] + ";\n				" + A + ": " + w + ";\n			}");
      }var i,
          r = t.cx - e.cx,
          l = t.cy - e.cy,
          c = t.width / e.width - 1,
          u = t.height / e.height - 1,
          f = e.width / t.width - 1,
          m = e.height / t.height - 1,
          p = n.easing || d,
          y = n.easingScale || p,
          h = n.duration / 50,
          v = [],
          g = [];for (i = 0; h > i; i += 1) {
        var b = 100 * (i / h),
            w = p(i / h),
            C = y(i / h);o(b, w, C);
      }return o(100, 1, 1), v = v.join("\n"), g = g.join("\n"), { fromKeyframes: v, toKeyframes: g };
    }var y = {};y.classCallCheck = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };var h = ["length", "parentRule"],
        v = void 0;v = "undefined" != typeof CSS2Properties ? Object.keys(CSS2Properties.prototype) : Object.keys(document.createElement("div").style).filter(function (e) {
      return !~h.indexOf(e);
    });var g = v,
        b = "http://www.w3.org/2000/svg",
        w = void 0;try {
      w = document.createElementNS(b, "svg"), w.style.position = "fixed", w.style.top = w.style.left = "0", w.style.width = w.style.height = "100%", w.style.overflow = "visible", w.style.pointerEvents = "none", w.setAttribute("class", "mogrify-svg");
    } catch (C) {
      console.log("The current browser doesn't support SVG");
    }var T = !1,
        R = window.requestAnimationFrame || window.webkitRequestAnimationFrame || function (e) {
      return setTimeout(e, 16);
    },
        x = function D(e, t, n) {
      function o() {
        var d = Date.now(),
            y = d - p;if (y > h) return e.clone.parentNode.removeChild(e.clone), t.clone.parentNode.removeChild(t.clone), void (n.done && n.done());var b = v(y / h),
            w = g(y / h);e.clone.style.opacity = 1 - b, t.clone.style.opacity = b;var C = s(e.borderRadius, t.borderRadius, l, c, b),
            T = s(t.borderRadius, e.borderRadius, u, m, 1 - b);f(e.clone, C), f(t.clone, T);var x = e.cx + i * b,
            S = e.cy + r * b,
            k = a(e.isSvg, x, S, i, r, l, c, b, w) + " " + e.transform,
            A = a(t.isSvg, x, S, -i, -r, u, m, 1 - b, 1 - w) + " " + t.transform;e.isSvg ? e.clone.setAttribute("transform", k) : e.clone.style.transform = e.clone.style.webkitTransform = e.clone.style.msTransform = k, t.isSvg ? t.clone.setAttribute("transform", A) : t.clone.style.transform = t.clone.style.webkitTransform = t.clone.style.msTransform = A, R(o);
      }y.classCallCheck(this, D);var i = t.cx - e.cx,
          r = t.cy - e.cy,
          l = t.width / e.width - 1,
          c = t.height / e.height - 1,
          u = e.width / t.width - 1,
          m = e.height / t.height - 1,
          p = Date.now(),
          h = n.duration || 400,
          v = n.easing || d,
          g = n.easingScale || v;o();
    },
        S = document.createElement("div"),
        k = !0,
        A = void 0,
        E = void 0,
        I = void 0,
        _ = void 0,
        N = void 0,
        j = void 0,
        L = void 0,
        O = void 0,
        B = !window.ActiveXObject && "ActiveXObject" in window;!B && ("transform" in S.style || "webkitTransform" in S.style) && ("animation" in S.style || "webkitAnimation" in S.style) ? (k = !0, A = "transform" in S.style ? "transform" : "-webkit-transform", "animation" in S.style ? (E = "@keyframes", I = "animationDirection", _ = "animationDuration", N = "animationIterationCount", j = "animationName", L = "animationTimingFunction", O = "animationend") : (E = "@-webkit-keyframes", I = "webkitAnimationDirection", _ = "webkitAnimationDuration", N = "webkitAnimationIterationCount", j = "webkitAnimationName", L = "webkitAnimationTimingFunction", O = "webkitAnimationEnd")) : k = !1;var F = function K(e, t, n) {
      function o() {
        u && f && (e.clone.parentNode.removeChild(e.clone), t.clone.parentNode.removeChild(t.clone), n.done && n.done(), c());
      }y.classCallCheck(this, K);var i = p(e, t, n),
          r = i.fromKeyframes,
          a = i.toKeyframes,
          s = "_" + ~~(1e6 * Math.random()),
          d = "_" + ~~(1e6 * Math.random()),
          l = E + " " + s + " { " + r + " } " + E + " " + d + " { " + a + " }",
          c = m(l);e.clone.style[I] = "alternate", e.clone.style[_] = n.duration / 1e3 + "s", e.clone.style[N] = 1, e.clone.style[j] = s, e.clone.style[L] = "linear", t.clone.style[I] = "alternate", t.clone.style[_] = n.duration / 1e3 + "s", t.clone.style[N] = 1, t.clone.style[j] = d, t.clone.style[L] = "linear";var u = void 0,
          f = void 0;e.clone.addEventListener(O, function () {
        u = !0, o();
      }), t.clone.addEventListener(O, function () {
        f = !0, o();
      });
    },
        M = { transform: function transform(t, o) {
        var i = arguments.length <= 2 || void 0 === arguments[2] ? {} : arguments[2];"function" == typeof i && (i = { done: i }), "duration" in i || (i.duration = 400);var a = !!i.appendToBody,
            s = r(o),
            d = n(t, s, i.overrideClone, a),
            l = n(o, s, i.overrideClone, a);return (d.isSvg || l.isSvg && !T) && e(), !k || i.useTimer || d.isSvg || l.isSvg ? new x(d, l, i) : new F(d, l, i);
      }, hide: function hide() {
        for (var e = arguments.length, t = Array(e), n = 0; e > n; n++) {
          t[n] = arguments[n];
        }t.forEach(o);
      }, show: function show() {
        for (var e = arguments.length, t = Array(e), n = 0; e > n; n++) {
          t[n] = arguments[n];
        }t.forEach(i);
      }, linear: d, easeIn: l, easeOut: c, easeInOut: u };return M;
  });
  //# sourceMappingURL=/www/ramjet/.gobble-build/11-uglifyjs/.cache/ramjet.umd.js.map
}